/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { IFiltersArrangement } from '@/interfaces/courseListing';
import FilterCategory from './FilterCategory';
import LoadingFilterCardSkeleton from '../../common/LoadingSkeleton/LoadingFilterCardSkeleton';
// import LoadingFilterCardSkeleton from '../common/LoadingSkeleton/LoadingFilterCardSkeleton';

type Props = {
  filteredData: { filterArrangement: IFiltersArrangement; dataLayerData: Record<string, string> };
  activeFilter: string | null;
  isLoading?: boolean;
};
const SortedFilterComponent = ({ filteredData, activeFilter, isLoading }: Props) => {
  const filterSectionOrder: (keyof IFiltersArrangement)[] = [
    // 'profession',
    'domain',
    'categories',
    'subCategories',
    'instructor',
    'language',
    'program',
    'level',
    'pricing',
    'tags',
  ];

  const filterComponentJSX = filterSectionOrder.map((key, index) => {
    let isEndOfObject = false;
    let isStartOfObject = false;
    if (index === 0) {
      isStartOfObject = true;
    }
    if (filterSectionOrder.length - 1 === index) {
      isEndOfObject = true;
    }
    const filteredList = filteredData.filterArrangement[key as keyof IFiltersArrangement];
    const filteredOptions = filteredList.filterOption.sort((a, b) => {
      if (a.title && b.title) {
        const fa = a.title?.toLowerCase();
        const fb = b.title?.toLowerCase();
        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      }
      return 0;
    });

    return (
      <FilterCategory
        isStartOfObject={isStartOfObject}
        isEndOfObject={isEndOfObject}
        key={filteredList.filterType}
        filterType={filteredList.filterType}
        filterOption={filteredOptions}
        type={filteredList.selectType}
        activeFilter={activeFilter}
      />
    );
  });

  return (
    <div>
      {isLoading ? (
        <div>
          <LoadingFilterCardSkeleton />
        </div>
      ) : (
        filterComponentJSX
      )}
    </div>
  );
};

export default SortedFilterComponent;
